<!-- 组件1   单商品 -->
<template>
     <div class="ThemeFour">
       <div class="mainBox"  :style="{background:ItemDate.topicColor}">
         <!--  :style="{backgroundImage:'url('+ItemDate.pictureAndLinkVOS[0].pic+')'}" -->
          <div class="conBox"  >
              <div class="leftBox" @click="jumpDetail(item.productVOS[0].id,item.productVOS[0].isRecentExpiration)">
                 <!-- :src="item.productVOS[0].albumPics.split(',')[0]| defaultImage" -->
                  <img :alt="item.productVOS[0].name | defaultName" :src="item.pic | defaultImage">
                  <span  v-if="item.productVOS[0].isReview==1" class="tag bgOrange">追溯码</span>
              </div>
              <div class="rightBox">
                  <h3 class="name" :title="item.productVOS[0].name">{{item.productVOS[0].name}}</h3>
                  <div class="special">规格：{{item.productVOS[0].specification}} {{item.productVOS[0].partSpecification}}</div>
                  <div class="special">效期优于：{{ item.productVOS[0].validDateFromat }}</div>
                  <div class="bottom">
                    <div class="price">￥{{item.productVOS[0].price==="***"?"会员可见":item.productVOS[0].price}}</div>
                    <div class="buy" @click="AddCart(item.productVOS[0].id,item.productVOS[0].minOrderNum,item.productVOS[0].isRecentExpiration,item.productVOS[0].goodNum)">去购买
                    </div>
                  </div> 
              </div>
              
              <div class="clear"></div>
          </div>
       </div>
    </div>
</template>
<script>
  export default {
    name: "ThemeFour",
    data() {
      return {
        item:''
      }
    },
    props: {
        // 滚动数组
        ItemDate: {
            type: Object
        },
    },
    created() {
       console.log('ThemeFour',this.ItemDate)
       this.item=this.ItemDate.pictureAndLinkVOS[0]
    },
    methods: {
      // 点击跳转详情页   js跳转app
      jumpDetail(id, isRecentExpiration) {
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let detailsData = {
          goods_id: id,
          isRecentExpiration: isRecentExpiration,
        }
        if (isiOS) {
          window.webkit.messageHandlers.jumpGoodsDetail.postMessage(detailsData)
        } else {
          this.$bridge.callHandler("jumpGoodsDetail", detailsData, res => {});
        }
      },
      // 点击加入购物车
      AddCart(id, minOrderNum, isRecentExpiration, goodNum) {
        // addShoppingCart(goods_id, isRecentExpiration,minOrderNum)
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let datas = {
          goods_id: id,
          isRecentExpiration: isRecentExpiration,
          minOrderNum: minOrderNum,
          goodNum: goodNum
        };
        console.log(datas);
        if (isiOS) {
          window.webkit.messageHandlers.addShoppingCart.postMessage(datas)
        } else {
          this.$bridge.callHandler("addShoppingCart", datas, res => {});
        }
      },
    },
     //   注册方法
    mounted() {

    }
  }
</script>
<style lang="scss" scoped>
.ThemeFour {
    width:100%;
    display: block;
    height: auto;
    .mainBox{ 
        padding:0.08rem;
         .conBox {
            width:100%;
            box-sizing: content-box;
          background-repeat: no-repeat;
          background-size: 100%;
          height: 100%;
          background: #fff;
          border-radius: 10px;
            .leftBox{
              width: 1.2rem;
              height: 1.2rem;
              // width:calc(40% - 0.16rem);
              float: left;
              padding: 0.08rem;
              position: relative;
              img{
                width: 100%;
                height: 100%;
              }
              .tag{
                    position: absolute;
                    right: 0.1rem;
                    top:0.1rem;
                    width:0.36rem;
                    border-radius:0.05rem;
                      text-align: center;
                      height:0.2rem;
                      line-height: 0.24rem;
                      font-size:0.11rem;
                  }
                  .bgOrange{
                    background-color:#f3fcf2;
                    border: 1px solid  #FF7A45;
                    color:#FF7A45;
                  }
            }
            .rightBox{
              width:calc( 100% - 1.52rem );
              //  width:calc(60% - 0.16rem);
               float: left;
              display: block;
              padding: 0.08rem;
              
              .name {
                padding:0.08rem 0;
                color: #333;
                font-size: 0.12rem;
                line-height: 0.21rem;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                text-align: left;
              }
                .special {
                  color:  #525252;
                  font-size: 0.12rem;
                  line-height: 0.2rem;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  text-align: left;
                }

                .bottom {
                  margin-top: 0.1rem;
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                }

                .price {
                  color: #ff3333;
                  font-size: 0.14rem;
                  font-weight: bold;
                }

                .buy {
                  background: #ff3333;
                  color: #fff;
                  font-size: 0.14rem;
                  border-radius: 0.06rem;
                  padding: 0.04rem 0.1rem;
                }


            }
            .clear{
              clear: both;
            }
          }
    }
     
  }
</style>


// WEBPACK FOOTER //
// src/components/ActivityTheme/ThemeFour.vue